// extracted by mini-css-extract-plugin
module.exports = {"hotspot":"Hotspot_hotspot__nzhn3"};